export default __webpack_public_path__ + "static/data-18a964f737a246e2bd8366ed34674416.svg";